module.exports = __webpack_public_path__ + "img/city1.6a099ad5.png";